export default "__VITE_ASSET__5c4c4eff__"